/* eslint-disable no-param-reassign */
import { removeTrapFocus, trapFocus } from "./global"; // eslint-disable-line

// Dynamic mini-cart regions replaced on every cart update. .mini-cart-recommendations
// is intentionally excluded so the hydrated Searchspring widget is preserved across
// updates instead of being torn down and re-inserted as an inert placeholder.
const MINI_CART_REGIONS = [
	".mini-cart-heading",
	".mini-cart-items",
	".mini-cart-action",
];

function updateMiniCartRegions(html) {
	const content = document.querySelector(".mini-cart-content");
	if (!content) return;
	const next = new DOMParser().parseFromString(html, "text/html");
	MINI_CART_REGIONS.forEach((selector) => {
		const newNode = next.querySelector(selector);
		const oldNode = content.querySelector(selector);
		if (newNode && oldNode) {
			oldNode.replaceWith(newNode);
		} else if (newNode) {
			content.appendChild(newNode);
		} else if (oldNode) {
			oldNode.remove();
		}
	});
	// Keep the persistent recommendations widget hidden while the cart is empty
	// (BR-866) without re-rendering it, mirroring the server-rendered hidden state.
	const recommendations = content.querySelector(".mini-cart-recommendations");
	const nextRecommendations = next.querySelector(".mini-cart-recommendations");
	if (recommendations) {
		recommendations.hidden = nextRecommendations
			? nextRecommendations.hidden
			: true;
	}
}

class CartNotification extends HTMLElement {
	constructor() {
		super();

		this.cartEventQty = 0;
		this.cartEventKey = 0;

		this.notification = document.getElementById("cart-notification");
		this.header = document.querySelector("sticky-header");
		this.onBodyClick = this.handleBodyClick.bind(this);

		this.notification.addEventListener(
			"keyup",
			(evt) => evt.code === "Escape" && this.close(),
		);

		document
			.getElementsByTagName("sticky-header")[0]
			.addEventListener("click", (e) => {
				if (e.target.classList.contains("header__icon--cart")) {
					this.open();
					e.preventDefault();
				}
			});

		document
			.querySelector(".mini-cart")
			.querySelectorAll(".quantity__input")
			.forEach((cartQty) => {
				cartQty.value = cartQty.getAttribute("data-val");
			});

		document
			.getElementById("cart-notification")
			.addEventListener("change", (e) => {
				if (e.target.getAttribute("type") === "number") {
					const itemKey = e.target.getAttribute("data-key");
					const itemValue = e.target.value;
					this.changeItem(itemKey, itemValue);
				}
			});

		document
			.getElementById("cart-notification")
			.addEventListener("click", (e) => {
				if (e.target.classList.contains("cart-notification__close")) {
					this.close();
				}
				if (
					e.target.getAttribute("name") === "plus" ||
					e.target.getAttribute("name") === "minus"
				) {
					const qtyInput = e.target
						.closest("div.quantity-input")
						.querySelector("input.quantity__input");
					const qtyKey = qtyInput.getAttribute("data-key");
					// eslint-disable-next-line radix
					let qtyInputVal = parseInt(qtyInput.value, 10);

					if (e.target.getAttribute("name") === "plus") {
						qtyInput.value = qtyInputVal + 1;
					} else if (e.target.getAttribute("name") === "minus") {
						if (qtyInputVal !== 0) {
							qtyInput.value = qtyInputVal - 1;
						}
					}
					// eslint-disable-next-line radix
					qtyInputVal = parseInt(qtyInput.value, 10);
					this.open();
					this.changeItem(qtyKey, qtyInputVal);

					this.cartEventKey = qtyKey;
					this.cartEventQty = qtyInput?.dataset?.inventoryQuantity || 0;
				}
				if (e.target.getAttribute("name") === "remove") {
					const qtyInput = e.target
						.closest(".cart-item")
						.querySelector("input.quantity__input");
					const qtyKey = qtyInput.getAttribute("data-key");
					this.cartEventKey = qtyKey;
					this.cartEventQty = 0;

					this.open();
					this.changeItem(qtyKey, 0);
				}
			});
	}

	changeItem(itemKey, itemValue) {
		this.notification.classList.add("loading");
		fetch(`/cart/change?id=${itemKey}&quantity=${itemValue}`, {
			method: "post",
		})
			.then(() => {
				this.notification.classList.remove("loading");
				this.fetchRenderItem("change");
				window.updateCartCount();
				// eslint-disable-next-line no-console
			})
			.catch((err) => console.warn("Something went wrong.", err));
	}

	open() {
		this.notification.classList.add("active");
		this.notification.addEventListener(
			"transitionend",
			() => {
				this.notification.focus();
				trapFocus(this.notification);
			},
			{ once: true },
		);
		document.body.addEventListener("click", this.onBodyClick);
	}

	close() {
		this.notification.classList.remove("active");
		document.body.removeEventListener("click", this.onBodyClick);
		removeTrapFocus(this.activeElement);
	}

	renderContents(parsedState) {
		this.fetchRenderItem(parsedState);
		this.open();
	}

	fetchRenderItem(eventTrigger) {
		const eventTriggerVar = eventTrigger;
		fetch("/cart?view=mini")
			.then((response) => response.text())
			.then((html) => {
				updateMiniCartRegions(html);
				const cartCount = document.querySelector(".mini-count").textContent;
				document
					.querySelectorAll(".cart-count-bubble")
					.forEach((cartBubble) => {
						cartBubble.innerHTML = cartCount;
					});
				document
					.querySelector(".mini-cart")
					.querySelectorAll(".quantity__input")
					.forEach((cartQty) => {
						cartQty.value = cartQty.getAttribute("data-val");
					});
				this.notification.classList.remove("loading");
				if (eventTriggerVar === "change") {
					const cartEventQtyCurrent = document.querySelector(
						`input[data-key="${this.cartEventKey}"]`,
					).value;
					if (cartEventQtyCurrent === this.cartEventQty) {
						// error qty
						const itemErrorElement = document
							.querySelector(`input[data-key="${this.cartEventKey}"]`)
							.closest(".cart-info")
							.querySelector(".cart-item__error");
						const itemErrorTextElement = document
							.querySelector(`input[data-key="${this.cartEventKey}"]`)
							.closest(".cart-info")
							.querySelector(".cart-item__error-text");

						if (itemErrorElement) {
							itemErrorElement.style.display = "flex";
						}
						if (itemErrorTextElement) {
							itemErrorTextElement.innerHTML =
								window.cartStrings.quantityError.replace(
									"[quantity]",
									cartEventQtyCurrent,
								);
						}
					}
				} else if (eventTriggerVar) {
					const targetItemQtyCurrent = document.querySelector(
						`input[data-variant-id="${eventTriggerVar.itemID}"]`,
					).value;
					if (targetItemQtyCurrent === eventTriggerVar.itemQuantiy) {
						const itemErrorElement = document
							.querySelector(
								`input[data-variant-id="${eventTriggerVar.itemID}"]`,
							)
							.closest(".cart-info")
							.querySelector(".cart-item__error");
						const itemErrorTextElement = document
							.querySelector(
								`input[data-variant-id="${eventTriggerVar.itemID}"]`,
							)
							.closest(".cart-info")
							.querySelector(".cart-item__error-text");

						if (itemErrorElement) {
							itemErrorElement.style.display = "flex";
						}
						if (itemErrorTextElement) {
							itemErrorTextElement.innerHTML =
								window.cartStrings.quantityError.replace(
									"[quantity]",
									targetItemQtyCurrent,
								);
						}
					}
				}
			})
			// eslint-disable-next-line no-console
			.catch((err) => console.warn("Something went wrong.", err));
	}

	getSectionsToRender() {
		return [
			{
				id: "cart-notification-product",
				selector: `#cart-notification-product-${this.productId}`,
			},
			{
				id: "cart-notification-button",
			},
			{
				id: "cart-icon-bubble",
			},
		];
	}

	/* eslint-disable class-methods-use-this */
	getSectionInnerHTML(html, selector = ".shopify-section") {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector).innerHTML;
	}
	/* eslint-enable class-methods-use-this */

	handleBodyClick({ target }) {
		if (
			target !== this.notification &&
			!target.closest("cart-notification") &&
			target.id !== "cart-icon-bubble"
		) {
			const disclosure = target.closest("details-disclosure");
			this.activeElement = disclosure
				? disclosure.querySelector("summary")
				: null;
			this.close();
		}
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.get("cart-notification") ||
	customElements.define("cart-notification", CartNotification); // eslint-disable-line
